<template>
  <div class="app-container bj-label-colon">
    <BjDivider right-fixed
      >{{ $t('routeBusinessStockDeliveryInformView.Basic') }}
      <template slot="right">
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        <BjLogButton
          :id="data.id"
          permission="BusinessStockDeliveryInformIndex_Log"
          :title="data.code"
          api="stockApi"
        />
      </template>
    </BjDivider>
    <el-row>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Delivery')">
            {{ data.code }}
            <BjCopyIcon class="ml10" :copy="data.code" />
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Outbound')">
            {{ data.outLogicWarehouseCode }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Name')">
            {{ data.outLogicWarehouseName }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Issue')">
            {{ data.outTypeMeaning }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.status')">
            {{ $t(ORDER_STOCK_OUT_TYPE_LIST.bjGet(data.status)) }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Buyer')">
            {{ data.buyMsg }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Merchant')">
            {{ data.orderMsg }}
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Logistics')">
            {{ data.logisticCompany }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.business')">
            {{ data.logisticBusiness }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Consignee')">
            <BjDecrypt
              :row="data"
              row-key="receiverNameMask"
              :channel="data.channelTypeCode"
              :type="ORDER_DECRYPT_NAME['receiverNameMask']"
              :order-sn="data.platformOrderCode"
            />
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Contact')">
            <BjDecrypt
              :row="data"
              row-key="receiverPhoneMask"
              :channel="data.channelTypeCode"
              :type="ORDER_DECRYPT_NAME['receiverPhoneMask']"
              :order-sn="data.platformOrderCode"
            />
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Shipping')">
            <BjDecrypt
              :row="data"
              row-key="addressMask"
              :channel="data.channelTypeCode"
              :type="ORDER_DECRYPT_NAME['addressMask']"
              :order-sn="data.platformOrderCode"
            />
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Creation')">
            {{ data.creationDate }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Created')">
            {{ data.createdName }}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <BjDivider>{{ $t('routeBusinessStockDeliveryInformView.Associated') }}</BjDivider>
    <el-form inline>
      <el-col :span="8">
        <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Pre')">
          <span @click="onView(0)">{{ data.frontRecordCode }}</span>
          <BjCopyIcon class="ml10" :copy="data.frontRecordCode" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Internal')">
          <span class="link" @click="$toBusinessOrderInternalView(data.orderCode)">{{
            data.orderCode
          }}</span>
          <BjCopyIcon class="ml10" :copy="data.orderCode" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('routeBusinessStockDeliveryInformView.Third')">
          <span class="link" @click="$toBusinessThirdOrderView(data.platformOrderCode)">{{
            data.platformOrderCode
          }}</span>
          <BjCopyIcon class="ml10" :copy="data.platformOrderCode" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('routeBusinessStockDeliveryInformView.result')">
          <span class="link">
            <span v-for="(item, index) in data.resultCodeAndIdList" :key="index">
              <span @click="$toBusinessStockDeliveryResultView(item.id)">{{
                index > 1 ? '' : item.code
              }}</span>
              <span v-if="data && data.resultCodeAndIdList.length > 1">{{
                index === 0 ? '，' : ''
              }}</span>
            </span>
          </span>
          <!--
            ① 超过两个结果单用...显示，并且点击是弹窗到 【查看出库结果单号】
          -->
          <el-button
            v-if="data && data.resultCodeAndIdList.length > 2"
            type="text"
            class="ml10"
            size="small"
            @click="onMore"
            >{{ $t('routeBusinessStockDeliveryInformView.View') }}</el-button
          >
        </el-form-item>
      </el-col>
    </el-form>
    <BjDivider>{{ $t('routeBusinessStockDeliveryInformView.Product') }}</BjDivider>
    <!-- TODO:商品明细应该只有一条 by skyer-ebc-325 -->
    <BjPage
      ref="BjPage"
      :col-span="colSpan"
      :get-action="queryApi"
      :query-params="queryParams"
      :serial="serial"
      :selection="false"
      :stripe="false"
      search-btn-hide
      right-toolbar-hide
      row-key="id"
      no-auto-height
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm> </template>
      <template #startBtnGroup>
        <!-- <el-button type="primary">解挂</el-button> -->
      </template>
      <template v-slot:tableColumn>
        <!-- <el-table-column :label="$t('goodsPage.spuCode')" prop="spuCode" align="center" /> -->
        <el-table-column :label="$t('routeBusinessStockDeliveryInformView.SKU')" prop="skuName" align="center" />
        <el-table-column :label="$t('routeBusinessStockDeliveryInformView.SKUcode')" prop="skuCode" align="center" />
        <el-table-column :label="$t('routeBusinessStockDeliveryInformView.Shipment')" prop="plannedQty" align="center" />
        <el-table-column :label="$t('routeBusinessStockDeliveryInformView.Quantity')" prop="alreadyOutQty" align="center" />
        <!-- <el-table-column :label="$t('goodsPage.spuName')" prop="spuName" align="center" /> -->
      </template>
      <template #paginationLeft>
        <span>{{ $t('routeBusinessStockDeliveryInformView.Total') }}{{ qtyData.plannedQty }} </span
        ><span class="ml20">{{ $t('routeBusinessStockDeliveryInformView.shipped') }}{{ qtyData.alreadyOutQty }}</span>
      </template>
    </BjPage>
    <tableDialog ref="codeTable" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';
import { ORDER_STOCK_OUT_TYPE_LIST, ORDER_DECRYPT_NAME } from '@/utils/constants';
import tableDialog from '../components/tableDialog.vue';
export default {
  name: 'BusinessStockDeliveryInformView',
  components: { tableDialog },
  mixins: [pageMiXin, viewMiXin],
  props: {},
  data() {
    return {
      ORDER_STOCK_OUT_TYPE_LIST,
      ORDER_DECRYPT_NAME,
      queryApi: stockApi.getOutboundDeliveryDetailPage,
      queryParams: {
        odoId: this.$route.query.id,
      },
      colSpan: 12,
      id: null,
      data: {
        resultCodeAndIdList: [],
      },
      qtyData: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getData(this.id);
  },
  mounted() {},
  methods: {
    getData(id) {
      stockApi
        .getOutboundDeliveryDetail({ id })
        .then(res => {
          this.data = res;
        });
      stockApi
        .getOutboundDeliveryDetailStats(id)
        .then(res => {
          this.qtyData = res;
        });
    },
    onView(type) {
      switch (type) {
        case 0:
          // TODO: 这里需要以后过来接，现在没数据
          // this.msgSuccess('跳转前置页面');
          break;
        case 1:
          this.$toBusinessOrderInternalView(this.data.orderCode);
          break;
        case 2:
          // TODO: 这里需要以后过来接，现在没数据
          this.$toBusinessThirdOrderView(this.data.platformOrderCode);
          break;
      }
    },
    handleClose() {
      this.cancel();
    },
    /** 查看更多 */
    onMore() {
      this.$refs.codeTable.show(this.data.resultCodeAndIdList);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item--mini.el-form-item {
  margin-bottom: 5px;
}
</style>
